import { IOptionsButtonProps } from "@/components/options-button/interface";
import { IconButton } from "@mui/material";
import { useStyle } from "@/components/options-button/style";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {
  Children,
  cloneElement,
  isValidElement,
  ReactElement,
  useState,
} from "react";
import { useTheme } from "@/contexts/theme";
import { GoMakeMenu } from "../menu";

const OptionsButton = ({
  children,
  withCircle = true,
  menuSx,
  menuPaperProps,
}: IOptionsButtonProps) => {
  const { currentTheme, getIconOverride } = useTheme();
  const isHpClient = currentTheme === "hp-client";
  const { classes } = useStyle({
    withCircle,
    isHpClient,
  });
  const MoreIcon = getIconOverride("MoreVertIcon") ?? MoreVertIcon;
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleMoreOptionIconClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const menuContent =
    typeof children === "function"
      ? children(handleCloseMenu)
      : Children.map(children, (child) =>
          isValidElement(child)
            ? cloneElement(child as ReactElement, {
                onClick: (e: React.MouseEvent) => {
                  handleCloseMenu();
                  (child as ReactElement).props?.onClick?.(e);
                },
              })
            : child,
        );

  return (
    <>
      <IconButton
        onClick={handleMoreOptionIconClick}
        sx={[classes.button, isHpClient && { borderRadius: "8px !important" }]}
        size="small"
      >
        <MoreIcon sx={classes?.iconStyle} />
      </IconButton>
      <GoMakeMenu
        open={open}
        anchorEl={anchorEl}
        handleClose={handleCloseMenu}
        sx={menuSx}
        PaperProps={menuPaperProps}
      >
        {menuContent}
      </GoMakeMenu>
    </>
  );
};

export { OptionsButton };
